/**
 * Created by Administrador on 20/11/2017.
 */
(function(){
    'use strict';
    angular
        .module('completeAir')
        .controller('notificationCtrl', notificationCtrl)
        .controller('newEditNotificationCtrl', newEditNotificationCtrl)
        .controller('deleteNotificationCtrl', deleteNotificationCtrl);

    notificationCtrl.$inject = ['linkService', 'notifications'];

    newEditNotificationCtrl.$inject = ['notificationService', 'linkService', 'notification','action'];

    deleteNotificationCtrl.$inject = ['notification', 'notificationService', '$uibModalInstance','linkService'];

    function notificationCtrl(linkService, notifications){
        var vm = this;

        vm.notifications = (notifications.data._embedded) ? notifications.data._embedded.notifications : [];
        vm.linkService = linkService;
    }

    function newEditNotificationCtrl(notificationService, linkService, notification, action){
        var vm = this;
        vm.linkService = linkService;
        vm.notification = {};

        if(action == 'edit'){
            vm.notification.lang = notification.data.lang;
            vm.notification.percentage = notification.data.percentage;
            vm.notification.fixedAmount = notification.data.fixedAmount;
            vm.notification.type = notification.data.type;
            vm.notification.notificationId = vm.linkService.getLinkId(notification.data._links.self.href);
        }

        vm.save = function(isValid, notification){
            if (isValid) {
                notification.active = true;
                if(action == "new"){
                    notificationService.saveNotification(notification);
                }else{
                    notificationService.updateNotification(vm.notification.notificationId, vm.notification)
                }
            }
        }
    }

    function deleteNotificationCtrl(notification, notificationService, $uibModalInstance,linkService){
        var vm = this;
        vm.notification = notification.data;

        vm.delete = function(){
            notificationService.deleteNotification(linkService.getLinkId(notification.data._links.self.href))
                .then(function(){
                    $uibModalInstance.close(true);
                })
        }

        vm.cancel = function () {
            $uibModalInstance.dismiss('cancel');
        };
    }
})();
